import { render, staticRenderFns } from "./ItemsListOrders.vue?vue&type=template&id=22e2abdc&scoped=true"
import script from "./ItemsListOrders.vue?vue&type=script&lang=js"
export * from "./ItemsListOrders.vue?vue&type=script&lang=js"
import style0 from "./ItemsListOrders.vue?vue&type=style&index=0&id=22e2abdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e2abdc",
  null
  
)

export default component.exports